import {Feature} from '../../generated/types';

export type PartialFeature = {
	id: Feature['id'];
	title: Feature['title'];
	description?: Feature['description'];
	headingLevel?: Feature['headingLevel'] | null;
	parentId?: Feature['parentId'] | null;
	prerequisite?: Feature['prerequisite'] | null;
	levels?: Feature['levels'] | null;
	levelTitles?: Feature['levelTitles'] | null;
	features?: PartialFeature[];
};

export function groupFeatures(features: Array<Partial<Feature>>): PartialFeature[] {
	const result = JSON.parse(JSON.stringify(features)) as PartialFeature[];
	const withParent = result.filter((f) => f.parentId);

	withParent.forEach((f) => {
		const parent = result.find((feature) => feature.id === f.parentId);
		if (parent) {
			if (parent.features) parent.features.push(f as PartialFeature);
			else parent.features = [f as PartialFeature];
		}
	});

	return result;
}
